import styled from "styled-components";

export const Wrapper = styled.div`
    padding: 50px 0;
    display: block;
    width: 100%;
`;

export const Title = styled.div`
    font-size: 30px;
    font-weight: 500;
    margin: 0 0 25px;
    text-align: center;
    text-transform: uppercase;
`;
export const Description = styled.div`
    font-size: 22px;
    text-align: center;
`;
